import React from 'react';

const CardTitleHeader = ({ title }) => {
  return (
    <div className="card-title-header">
      <h4 className="card-title">{title || ''}</h4>
      <div className="card-cta"></div>
    </div>
  );
};

export default CardTitleHeader;
